import { render, staticRenderFns } from "./SetupUserRole.vue?vue&type=template&id=6f714613&"
import script from "./SetupUserRole.vue?vue&type=script&lang=js&"
export * from "./SetupUserRole.vue?vue&type=script&lang=js&"
import style0 from "./SetupUserRole.vue?vue&type=style&index=0&id=6f714613&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports